import { FC } from 'react'
import { SvgProps } from './svgProps'

const MultiPacksIcon: FC<SvgProps> = ({ width, height, color }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill={color || '#000000'}
    width={width || '32'}
    height={height || '32'}
    viewBox="0 0 20.286 20.286"
  >
    <g>
      <g>
        <path
          d="M15.947,10.335c0-0.233-0.188-0.421-0.423-0.421c-0.232,0-0.42,0.188-0.42,0.421c0,0.232,0.188,0.421,0.42,0.421
			C15.757,10.757,15.947,10.568,15.947,10.335z M15.673,10.152c0.03,0,0.055,0.024,0.055,0.054s-0.023,0.053-0.055,0.053
			c-0.029,0-0.053-0.024-0.053-0.053S15.644,10.152,15.673,10.152z"
        />
        <path
          d="M14.64,19.505c-0.168,0.014-0.302,0.15-0.302,0.323c0,0.182,0.146,0.328,0.327,0.328c0.146,0,0.266-0.098,0.309-0.229
			C14.8,19.854,14.671,19.696,14.64,19.505z M14.497,20.034c-0.029,0-0.055-0.023-0.055-0.053s0.023-0.053,0.055-0.053
			c0.029,0,0.053,0.023,0.053,0.053S14.526,20.034,14.497,20.034z"
        />
        <path
          d="M9.713,14.847c-0.283,0.021-0.508,0.252-0.508,0.542c0,0.304,0.246,0.551,0.55,0.551c0.246,0,0.446-0.165,0.518-0.387
			C9.98,15.434,9.765,15.166,9.713,14.847z M9.473,15.735c-0.05,0-0.09-0.041-0.09-0.09s0.04-0.089,0.09-0.089
			c0.049,0,0.089,0.04,0.089,0.089S9.522,15.735,9.473,15.735z"
        />
        <path
          d="M9.821,14.251c-0.086-0.123-0.222-0.208-0.383-0.208c-0.264,0-0.478,0.214-0.478,0.478c0,0.175,0.1,0.322,0.241,0.405
			c0.122-0.147,0.299-0.247,0.501-0.263C9.709,14.513,9.752,14.373,9.821,14.251z M9.203,14.394c-0.05,0-0.09-0.04-0.09-0.089
			c0-0.05,0.04-0.089,0.09-0.089c0.049,0,0.089,0.039,0.089,0.089C9.292,14.354,9.251,14.394,9.203,14.394z"
        />
        <path
          d="M5.279,10.422c-0.168,0.013-0.302,0.15-0.302,0.323c0,0.181,0.146,0.328,0.327,0.328c0.146,0,0.266-0.098,0.308-0.23
			C5.438,10.771,5.31,10.612,5.279,10.422z M5.136,10.951c-0.03,0-0.054-0.024-0.054-0.053c0-0.029,0.023-0.053,0.054-0.053
			c0.029,0,0.053,0.024,0.053,0.053C5.189,10.927,5.165,10.951,5.136,10.951z"
        />
        <path
          d="M10.619,13.993c-0.392,0-0.708,0.317-0.708,0.708c0,0.392,0.316,0.708,0.708,0.708c0.391,0,0.708-0.316,0.708-0.708
			C11.327,14.311,11.009,13.993,10.619,13.993z M10.868,14.573c-0.049,0-0.089-0.04-0.089-0.089s0.04-0.09,0.089-0.09
			c0.051,0,0.09,0.041,0.09,0.09S10.918,14.573,10.868,14.573z"
        />
        <path
          d="M5.343,10.067C5.291,9.994,5.211,9.943,5.114,9.943c-0.156,0-0.284,0.127-0.284,0.284c0,0.104,0.06,0.192,0.144,0.241
			c0.073-0.088,0.179-0.146,0.299-0.156C5.277,10.223,5.302,10.141,5.343,10.067z M4.975,10.152c-0.029,0-0.054-0.024-0.054-0.053
			c0-0.029,0.024-0.053,0.054-0.053s0.053,0.024,0.053,0.053C5.028,10.128,5.004,10.152,4.975,10.152z"
        />
        <path
          d="M5.818,9.914c-0.233,0-0.421,0.188-0.421,0.421c0,0.232,0.188,0.421,0.421,0.421c0.232,0,0.422-0.189,0.422-0.421
			C6.24,10.102,6.05,9.914,5.818,9.914z M5.966,10.259c-0.029,0-0.053-0.024-0.053-0.053s0.023-0.054,0.053-0.054
			c0.03,0,0.054,0.024,0.054,0.054S5.996,10.259,5.966,10.259z"
        />
        <path d="M16.117,19.703l0.03-0.269c-0.157-0.042-0.303,0.035-0.399,0.134C15.841,19.712,15.979,19.731,16.117,19.703z" />
        <path
          d="M6.088,19.535c0.003-0.065,0.021-0.128,0.052-0.182c-0.038-0.055-0.098-0.092-0.169-0.092
			c-0.116,0-0.212,0.094-0.212,0.211c0,0.078,0.045,0.143,0.107,0.179C5.92,19.585,5.999,19.542,6.088,19.535z M5.867,19.337
			c0.022,0,0.039,0.019,0.039,0.04c0,0.022-0.017,0.04-0.039,0.04c-0.021,0-0.039-0.018-0.039-0.04
			C5.828,19.355,5.845,19.337,5.867,19.337z"
        />
        <path
          d="M6.092,19.616c-0.124,0.01-0.224,0.112-0.224,0.24c0,0.134,0.108,0.244,0.243,0.244c0.108,0,0.197-0.073,0.229-0.171
			C6.211,19.875,6.116,19.759,6.092,19.616z M5.987,20.01c-0.022,0-0.04-0.019-0.04-0.04c0-0.022,0.018-0.04,0.04-0.04
			c0.021,0,0.039,0.018,0.039,0.04C6.026,19.991,6.008,20.01,5.987,20.01z"
        />
        <path
          d="M15.05,10.067c-0.052-0.073-0.132-0.124-0.229-0.124c-0.156,0-0.284,0.127-0.284,0.284c0,0.104,0.06,0.192,0.144,0.241
			c0.073-0.088,0.18-0.146,0.299-0.156C14.983,10.223,15.009,10.141,15.05,10.067z M14.683,10.152c-0.029,0-0.055-0.024-0.055-0.053
			c0-0.029,0.023-0.053,0.055-0.053c0.029,0,0.053,0.024,0.053,0.053C14.735,10.128,14.711,10.152,14.683,10.152z"
        />
        <path
          d="M6.494,19.239c-0.174,0-0.313,0.14-0.313,0.313c0,0.172,0.14,0.312,0.313,0.312c0.172,0,0.313-0.141,0.313-0.312
			C6.807,19.379,6.665,19.239,6.494,19.239z M6.604,19.496c-0.022,0-0.04-0.018-0.04-0.04c0-0.021,0.018-0.04,0.04-0.04
			s0.039,0.019,0.039,0.04S6.626,19.496,6.604,19.496z"
        />
        <path d="M6.587,20.286h0.156c-0.042-0.033-0.089-0.06-0.139-0.073C6.592,20.238,6.591,20.263,6.587,20.286z" />
        <path
          d="M15.011,11.072c0.146,0,0.266-0.098,0.309-0.23c-0.174-0.071-0.303-0.229-0.333-0.42c-0.169,0.013-0.302,0.15-0.302,0.323
			C14.685,10.925,14.83,11.072,15.011,11.072z M14.843,10.844c0.029,0,0.053,0.024,0.053,0.053c0,0.029-0.022,0.053-0.053,0.053
			c-0.029,0-0.054-0.024-0.054-0.053C14.789,10.868,14.813,10.844,14.843,10.844z"
        />
        <path d="M5.823,20.286h0.16c-0.003-0.024-0.005-0.052-0.012-0.075C5.918,20.224,5.868,20.25,5.823,20.286z" />
        <path
          d="M14.704,19.151c-0.053-0.073-0.132-0.124-0.229-0.124c-0.156,0-0.285,0.127-0.285,0.284c0,0.104,0.061,0.191,0.145,0.241
			c0.073-0.088,0.18-0.146,0.299-0.156C14.638,19.308,14.663,19.225,14.704,19.151z M14.336,19.236
			c-0.028,0-0.054-0.024-0.054-0.053c0-0.029,0.023-0.054,0.054-0.054s0.054,0.024,0.054,0.054
			C14.39,19.212,14.366,19.236,14.336,19.236z"
        />
        <path
          d="M15.179,18.997c-0.232,0-0.42,0.188-0.42,0.421s0.188,0.422,0.42,0.422s0.422-0.189,0.422-0.422
			C15.601,19.187,15.412,18.997,15.179,18.997z M15.328,19.344c-0.028,0-0.054-0.024-0.054-0.054c0-0.028,0.023-0.054,0.054-0.054
			s0.054,0.024,0.054,0.054C15.382,19.32,15.358,19.344,15.328,19.344z"
        />
        <path
          d="M11.691,8.999c-0.23,0-0.449-0.045-0.654-0.134l-0.923,0.179C9.32,9.133,8.474,8.65,7.603,8.136
			c-0.378-0.223-0.76-0.438-1.145-0.62L3.05,9.646l1.182,10.639h0.694c0.017-0.05,0.023-0.102-0.002-0.163
			c0.244-0.077,0.321-0.293,0.308-0.409c0.139,0.071,0.316,0.107,0.42-0.051c-0.098-0.099-0.257-0.169-0.417-0.036
			c0.025-0.146-0.013-0.302-0.3-0.395c0.087-0.205-0.149-0.375-0.218-0.47c0.177,0.027,0.368,0.117,0.492-0.044
			c0.189,0.173,0.416,0.132,0.508,0.062c0.009,0.156,0.065,0.328,0.256,0.337c0.035-0.133,0.017-0.305-0.178-0.377
			c0.139-0.051,0.255-0.162,0.191-0.458c0.222-0.026,0.25-0.315,0.298-0.423c0.064,0.167,0.083,0.378,0.285,0.404
			c-0.057,0.25,0.093,0.426,0.2,0.471c-0.13,0.084-0.248,0.217-0.169,0.382c0.184-0.014,0.239-0.183,0.248-0.337
			c0.093,0.07,0.319,0.111,0.508-0.062c0.124,0.161,0.315,0.072,0.492,0.044c-0.068,0.095-0.305,0.265-0.218,0.469
			c-0.287,0.093-0.325,0.25-0.3,0.395c-0.16-0.132-0.318-0.062-0.416,0.036c0.103,0.158,0.279,0.122,0.419,0.051
			c-0.014,0.115,0.063,0.332,0.308,0.408c-0.025,0.062-0.019,0.113-0.002,0.163h5.439c-0.002-0.032,0.003-0.062-0.013-0.098
			c0.328-0.104,0.434-0.396,0.414-0.55c0.188,0.095,0.427,0.145,0.564-0.069c-0.131-0.133-0.345-0.228-0.561-0.048
			c0.033-0.196-0.018-0.407-0.404-0.531c0.117-0.275-0.201-0.505-0.293-0.632c0.238,0.038,0.496,0.158,0.663-0.061
			c0.255,0.233,0.56,0.179,0.685,0.084c0.012,0.209,0.088,0.441,0.344,0.454c0.047-0.179,0.021-0.409-0.239-0.507
			c0.187-0.067,0.344-0.218,0.258-0.616c0.298-0.035,0.337-0.426,0.401-0.568c0.086,0.226,0.111,0.509,0.383,0.544
			c-0.075,0.336,0.125,0.573,0.27,0.634c-0.174,0.113-0.334,0.292-0.228,0.515c0.248-0.019,0.323-0.247,0.334-0.453
			c0.112,0.086,0.373,0.128,0.61-0.037l0.746-6.701c-0.133-0.013-0.268,0.007-0.356,0.127c-0.302-0.273-0.511-0.212-0.662-0.084
			c0.046-0.275-0.142-0.413-0.319-0.46c-0.117,0.228,0.045,0.41,0.221,0.523c-0.145,0.062-0.344,0.297-0.27,0.635
			c-0.271,0.035-0.297,0.318-0.383,0.544c-0.064-0.144-0.104-0.534-0.4-0.569c0.086-0.397-0.072-0.548-0.259-0.616
			c0.269-0.1,0.289-0.34,0.236-0.521c-0.185,0.044-0.382,0.183-0.332,0.465c-0.152-0.128-0.361-0.189-0.663,0.084
			c-0.18-0.24-0.537-0.079-0.693-0.062c0.151-0.188,0.385-0.351,0.28-0.604c0.328-0.104,0.433-0.396,0.414-0.55
			c0.187,0.095,0.426,0.145,0.563-0.069c-0.131-0.133-0.345-0.227-0.561-0.048c0.034-0.196-0.018-0.407-0.404-0.531
			c0.04-0.093,0.021-0.178-0.014-0.259h1.193c0.053,0.057,0.119,0.1,0.218,0.105c0.009-0.033,0.012-0.069,0.015-0.105h0.809
			c0.004,0.034,0.004,0.068,0.021,0.105c0.096-0.007,0.157-0.05,0.208-0.105h1.192c-0.033,0.081-0.053,0.166-0.014,0.259
			c-0.387,0.125-0.438,0.336-0.404,0.532c-0.215-0.178-0.428-0.084-0.56,0.048c0.138,0.213,0.376,0.164,0.563,0.069
			c-0.02,0.155,0.086,0.447,0.414,0.55c-0.027,0.066-0.029,0.127-0.018,0.184l0.182-1.641L14.17,7.734
			C13.333,8.406,12.528,8.999,11.691,8.999z M13.685,12.918c-0.154,0.215-0.689,0.6-0.492,1.062c-0.649,0.21-0.736,0.563-0.68,0.893
			c-0.361-0.299-0.721-0.142-0.939,0.081c0.232,0.357,0.633,0.274,0.947,0.116c-0.032,0.26,0.144,0.75,0.695,0.923
			c-0.177,0.426,0.215,0.7,0.471,1.016c-0.264-0.027-0.863-0.299-1.164,0.104c-0.508-0.459-0.857-0.356-1.113-0.142
			c0.077-0.462-0.236-0.693-0.538-0.773c-0.196,0.382,0.077,0.688,0.372,0.881c-0.241,0.104-0.578,0.5-0.451,1.065
			c-0.457,0.06-0.499,0.536-0.645,0.915c-0.107-0.241-0.174-0.896-0.673-0.957c0.144-0.668-0.12-0.92-0.434-1.035
			c0.45-0.167,0.485-0.57,0.396-0.875c-0.308,0.075-0.639,0.308-0.558,0.78c-0.256-0.214-0.607-0.317-1.113,0.142
			C7.463,16.71,6.862,16.98,6.6,17.008c0.255-0.314,0.646-0.59,0.471-1.016c0.552-0.173,0.728-0.663,0.696-0.923
			c0.313,0.159,0.714,0.242,0.947-0.117c-0.22-0.223-0.579-0.381-0.941-0.082c0.058-0.329-0.029-0.684-0.68-0.893
			c0.198-0.462-0.338-0.849-0.491-1.062c0.4,0.064,0.833,0.267,1.113-0.101c0.428,0.392,0.939,0.299,1.148,0.142
			c0.02,0.353,0.147,0.741,0.577,0.764c0.081-0.302,0.038-0.689-0.401-0.854c0.313-0.114,0.577-0.367,0.434-1.035
			c0.499-0.06,0.565-0.716,0.673-0.957c0.146,0.379,0.188,0.854,0.645,0.915c-0.127,0.565,0.21,0.962,0.451,1.065
			c-0.291,0.189-0.56,0.49-0.381,0.864c0.416-0.031,0.542-0.414,0.561-0.762c0.21,0.157,0.722,0.25,1.147-0.142
			C12.851,13.184,13.284,12.982,13.685,12.918z M7.35,9.905c-0.387,0.125-0.438,0.336-0.404,0.532
			c-0.216-0.178-0.429-0.084-0.56,0.048c0.138,0.213,0.376,0.164,0.563,0.069c-0.019,0.155,0.086,0.447,0.415,0.55
			c-0.105,0.253,0.127,0.417,0.279,0.604c-0.156-0.017-0.514-0.177-0.693,0.062c-0.302-0.273-0.51-0.212-0.662-0.084
			c0.046-0.275-0.141-0.413-0.32-0.46c-0.117,0.228,0.046,0.41,0.222,0.523c-0.145,0.062-0.345,0.298-0.27,0.635
			c-0.271,0.035-0.297,0.318-0.383,0.544c-0.064-0.144-0.104-0.534-0.401-0.569c0.086-0.397-0.071-0.548-0.258-0.616
			c0.269-0.1,0.289-0.34,0.236-0.521c-0.184,0.044-0.381,0.183-0.332,0.465c-0.152-0.128-0.361-0.189-0.663,0.084
			c-0.18-0.24-0.537-0.079-0.693-0.062c0.151-0.188,0.385-0.351,0.28-0.604c0.328-0.104,0.433-0.396,0.414-0.55
			c0.187,0.095,0.426,0.145,0.564-0.069c-0.131-0.133-0.345-0.227-0.561-0.048c0.034-0.196-0.018-0.407-0.404-0.531
			c0.04-0.093,0.021-0.178-0.014-0.259h1.194c0.052,0.057,0.118,0.1,0.217,0.105C5.125,9.72,5.128,9.684,5.131,9.648h0.808
			c0.004,0.034,0.005,0.068,0.022,0.105c0.095-0.007,0.157-0.05,0.208-0.105h1.193C7.33,9.727,7.31,9.812,7.35,9.905z"
        />
        <path
          d="M17.386,3.727c-2.354-0.47-3.881,4.58-5.69,4.087c0.556-0.355,1.187-1.146,1.682-2.18
			c0.793-1.661,0.935-3.316,0.315-3.699c-0.543-0.338-1.487,0.417-2.249,1.725c-0.049-0.168-0.093-0.334-0.153-0.5
			c-0.826-2.235-2.439-3.594-3.605-3.034C6.52,0.684,6.244,2.948,7.069,5.183c0.418,1.135,1.042,2.041,1.707,2.588
			C7.235,7.054,5.787,3.936,4.128,4.233c-1.719,0.308-1.563,1.68-2.291,1.552l0.979,2.681c1.619,0.032,0.252-1.684,1.869-1.907
			c2.258-0.31,4.331,2.521,5.752,1.783c0.202-0.104,0.346-0.172,0.417-0.225c0.036,0,0.065,0.004,0.104,0.003
			c1.656,1.46,4.137-3.123,6.318-2.483c1.076,0.316,0.586,1.383-0.196,2.257C19.015,6.399,18.694,3.989,17.386,3.727z M10.47,7.668
			c-0.088,0.042-0.18,0.064-0.273,0.073c-0.006,0.002-0.012,0.002-0.018,0.004c-0.699,0.054-1.541-0.762-2-2.004
			C7.657,4.321,7.832,2.885,8.574,2.53c0.74-0.355,1.766,0.507,2.289,1.927c0.03,0.082,0.051,0.163,0.076,0.244
			c-0.486,1.194-0.623,2.313-0.374,2.898C10.533,7.621,10.505,7.651,10.47,7.668z M10.849,7.31
			c-0.157-0.382-0.061-1.113,0.262-1.883C11.228,6.197,11.13,6.885,10.849,7.31z M11.333,7.562c0.423-0.718,0.533-1.855,0.305-3.1
			c0.432-0.606,0.908-0.924,1.2-0.742c0.394,0.243,0.304,1.295-0.2,2.35C12.25,6.882,11.731,7.452,11.333,7.562z"
        />
      </g>
    </g>
  </svg>
)

export default MultiPacksIcon
